module.exports = __webpack_public_path__ + "img/aq.2e181d4b.svg";